export default defineNuxtRouteMiddleware(async to => {
    // Initial documents are guarded by Nitro before any app plugins or layout load.
    if (import.meta.server || useNuxtApp().isHydrating) return;
    try {
        const status = await $fetch('/api/backend-status', { timeout: 4500, retry: 0 });
        if (status.available) return;
    } catch {
        // A full document request can still show the standalone server fallback.
    }
    return navigateTo(to.fullPath, { external: true });
});
